<template>
  <svg width="100%" height="100%" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.8688 5.35178C20.4862 4.89637 19.8395 4.63222 19.1473 4.63222H18.9014V3.71228C18.9014 2.55554
            17.9632 1.62649 16.8156 1.62649H6.86941C6.6417 0.715665 5.82196 0.0507812 4.84738 0.0507812H2.34262C1.18587
            0.0507812 0.256836 0.988937 0.256836 2.13657V13.7496C0.256836 14.1777 0.384351 14.5875 0.612056 14.9154C0.985494
            15.471 1.62306 15.8353 2.34262 15.8353H16.8156C16.9613 15.8353 17.098 15.8171 17.2346 15.7898C17.2801 15.7807
            17.3257 15.7625 17.3621 15.7534C17.4532 15.726 17.5352 15.7078 17.6171 15.6714C17.6627 15.6532 17.7082 15.6168
            17.7538 15.5985C17.8266 15.5621 17.8995 15.5257 17.9632 15.4801C18.0088 15.4528 18.0452 15.4073 18.0908
            15.3799C18.1545 15.3344 18.2183 15.2888 18.2729 15.2342C18.3094 15.1978 18.3458 15.1522 18.3822 15.1067C18.4278
            15.052 18.4824 14.9974 18.528 14.9336C18.5644 14.8881 18.5826 14.8334 18.619 14.7788C18.6555 14.715 18.6919
            14.6513 18.7283 14.5875C18.7557 14.5329 18.7648 14.4691 18.783 14.4145C18.8103 14.3416 18.8285 14.2779 18.8467
            14.205C18.8559 14.1412 18.865 14.0774 18.8741 14.0137C18.8832 13.9499 18.9014 13.8862 18.9014 13.8224L21.2331
            6.79087C21.3242 6.24437 21.1967 5.74343 20.8688 5.35178ZM1.15856 2.12746C1.15856 1.48077 1.68683 0.952487 2.33351
            0.952487H4.83828C5.47585 0.952487 5.99503 1.45344 6.01325 2.09102L6.03145 2.52822H16.8065C17.4532 2.52822 17.9815
            3.05651 17.9815 3.70319V4.6231H4.66522C3.45382 4.6231 3.04396 5.42464 2.59766 6.57228L1.14944
            10.926V2.12746H1.15856ZM18.8923 10.926L18.0088 13.5947L17.9815 13.7405C17.9815 14.3871 17.4532 14.9154 16.8065
            14.9154H2.33351H2.32441C2.16957 14.9154 2.02383 14.879 1.8872 14.8243C1.84166 14.8061 1.79613 14.7606 1.75059
            14.7424C1.66861 14.6968 1.58664 14.6513 1.51378 14.5875C1.46824 14.542 1.4409 14.4873 1.40447 14.4418C1.34982
            14.3689 1.29518 14.3052 1.25875 14.2232C1.23142 14.1685 1.23142 14.0957 1.2132 14.041C1.19499 13.959 1.16766
            13.8771 1.15856 13.7951L3.45382 6.88196C3.89102 5.76164 4.0914 5.53393 4.66522 5.53393H17.9815H18.8923H19.1382C19.5663 5.53393
            19.9579 5.68877 20.1674 5.93469C20.3223 6.11686 20.3769 6.35368 20.3405 6.57228L18.8923 10.926Z"
      fill="#969696" />
  </svg>
</template>

<script>
export default {
  name: 'ICFolderIcon'
}
</script>
